/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ErrorDef } from './errorDef';


export interface ErrorModule { 
    errors?: Array<ErrorDef>;
    moduleCode?: string;
    moduleDefaultErrorMessage?: string;
    moduleDescription?: string;
    moduleName?: string;
}

